import type { StateWorkspaceSummary } from '@/lib/apiTypes'

// ── Sidebar row ────────────────────────────────────────────────────────────────
export function SidebarWorkspaceRow({ ws, isSelected, onSelect }: { ws: StateWorkspaceSummary; isSelected: boolean; onSelect: () => void }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2, borderRadius: 5, background: isSelected ? 'var(--accent-d)' : 'transparent' }}>
      <button
        onClick={onSelect}
        style={{ flex: 1, textAlign: 'left', padding: '7px 10px', border: 'none', cursor: 'pointer', background: 'transparent', color: isSelected ? 'var(--accent)' : 'var(--text2)', fontFamily: 'var(--mono)', fontSize: '0.75rem', borderRadius: 5, minWidth: 0 }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <span style={{ marginRight: 2 }}>{ws.name}</span>
          {ws.blocked === 1 && <span className="badge badge-red" style={{ fontSize: '0.6rem' }}>blocked</span>}
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 3, flexWrap: 'wrap' }}>
          {ws.latest_serial !== null && (
            <span style={{ fontFamily: 'var(--mono)', fontSize: '0.63rem', color: 'var(--text3)' }}>state serial {ws.latest_serial}</span>
          )}
        </div>
      </button>
    </div>
  )
}
